import { DEFAULT_POLL_INTERVAL_MS } from '~/eds/src/constants/duration';
import { api } from '~/redux/api/createApi';
import { Nullable } from '~/types/Nullable';
import { Uuid } from '~/types/Uuid';

import { PromptModelPublishStatus } from '../../../redux/api/types/sylvanus/model';
import { ModelProgress } from '../types/model';
import { testIsPublishingStatus } from '../utils/status';

const initialProgress = {
  docsProcessed: 0,
  docsInScope: 0,
  docsInScopeProcessing: false,
  optimizeState: null,
  publishStatus: null,
  valuesFound: 0,
};

interface Props {
  modelId: Nullable<Uuid>;
  publishStatus: Nullable<PromptModelPublishStatus>;
  enablePolling?: boolean;
}

/**
 * TODO: Deprecate this in favor of shared solution of usePollModelVersionProgress
 * This shareable hook conditionally polls the publish progress given a modelId.
 */
export const DEPRECATED_usePollModelProgress = ({
  modelId,
  publishStatus,
  enablePolling = false,
}: Props): {
  isLoading: boolean;
  progress: ModelProgress;
} => {
  const {
    data: progress = initialProgress,
    isLoading, // use isLoading over isFetching as we are only indicating the initial loading state for this polled request
  } = api.endpoints.getPromptModelProgress.useQuery(
    {
      modelId,
    },
    {
      pollingInterval:
        testIsPublishingStatus(publishStatus) || enablePolling
          ? DEFAULT_POLL_INTERVAL_MS
          : undefined,
      skip: !modelId,
    },
  );

  return {
    progress,
    isLoading,
  };
};
